function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512pt",
  viewBox: "-6 0 512 512",
  width: "512pt",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M416 512H0V104.64L122.078 0H416zm0 0",
  fill: "#e4edfb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.375 496L308.687 331.312l22.625-22.625L496 473.375c6.246 6.25 6.246 16.379 0 22.625s-16.375 6.246-22.625 0zm0 0",
  fill: "#57565c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 104.64h122.078V0zm0 0",
  fill: "#48c8ef"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64 416h32v32H64zm0 0M128 416h32v32h-32zm0 0M192 416h32v32h-32zm0 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M368 248c0 66.273-53.727 120-120 120s-120-53.727-120-120 53.727-120 120-120 120 53.727 120 120zm0 0",
  fill: "#57565c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336 248c0 48.602-39.398 88-88 88s-88-39.398-88-88 39.398-88 88-88 88 39.398 88 88zm0 0",
  fill: "#48c8ef"
})));